// Google Ads Conversion Tracking Utilities

// Declare gtag for TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

/**
 * Track signup conversion
 * Fires when a user successfully registers for an account
 */
export const trackSignupConversion = () => {
  if (typeof window.gtag === 'function') {
    console.log('🎯 Google Ads: Tracking signup conversion');
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17893228923/rNqsCPejzeobEPuClNRC'
    });
  } else {
    console.warn('⚠️ Google Ads gtag not loaded - signup conversion not tracked');
  }
};

/**
 * Track purchase conversion
 * Fires when a user successfully completes a payment
 * @param value - Transaction value in USD
 * @param currency - Currency code (default: USD)
 * @param transactionId - Optional order/transaction ID
 */
export const trackPurchaseConversion = (value: number, currency: string = 'USD', transactionId?: string) => {
  if (typeof window.gtag === 'function') {
    console.log('🎯 Google Ads: Tracking purchase conversion', { value, currency, transactionId });
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17893228923/rNqsCPejzeobEPuClNRC', // Using same conversion ID for now
      'value': value,
      'currency': currency,
      'transaction_id': transactionId
    });
  } else {
    console.warn('⚠️ Google Ads gtag not loaded - purchase conversion not tracked');
  }
};
